import { useState, useEffect } from 'react';
import { acMobileFeatures } from '@arnoldclark/ac-mobile-features';
import Auth from '@javascript/lib/auth';

import type { AsyncResult } from '@javascript/types/AsyncResult';

const { isLoggedIn: mobileAppLoggedIn, isNativeApp } = acMobileFeatures();

interface AuthenticationCheck extends AsyncResult {
  isLoggedIn: boolean;
  isMobileApp: boolean;
}

export default function useAuth(): AuthenticationCheck {
  const [state, setState] = useState<AuthenticationCheck>({
    isLoggedIn: mobileAppLoggedIn(),
    loading: !isNativeApp(),
    error: null,
    isMobileApp: isNativeApp(),
  });

  useEffect(() => {
    if (state.isMobileApp) return;

    (async () => {
      try {
        const auth = await new Auth().initializeAuthClient(window.authOptions);

        const isAuthenticated = await auth.isAuthenticated();

        setState({
          ...state,
          error: null,
          isLoggedIn: isAuthenticated,
          isMobileApp: false,
          loading: false,
        });
      } catch (error) {
        setState({
          ...state,
          error: error as Error,
          isLoggedIn: false,
          isMobileApp: false,
          loading: false,
        });
      }
    })();
  }, []);

  return state;
}
